
import React, { useState } from 'react';
import firebase from 'firebase/app';
//we need firebase because we're saving data files to the cloud, and we want to authorize people
import axios from 'axios';
import { config } from '../config';
import { useAppSelector } from '../redux/hooks';
import { store } from '../redux/store';
import { load } from '../redux/reducers/packetDataSlice';
import { selectProjectId } from '../redux/reducers/projectIdSlice';
import { selectData } from '../redux/reducers/packetDataSlice'
import OpenDataModal from './OpenDataModal';

const MotionTable = (props) => {
    const packetData = useAppSelector(selectData);
    const projectId = useAppSelector(selectProjectId);
    const [dataModalOpen, setDataModalOpen] = useState(false);

    let row = 0;

    const toggleModal = () => {
        setDataModalOpen(!dataModalOpen);
    }

    const clearPacketData = () => {
        store.dispatch(load([]));
    };

    const saveToCloud = () => {
        firebase.auth().currentUser.getIdToken(false).then(idToken => {

            //This post may need to be changed to a put. According to the api integration there's only cases for put not post.
            //Though this then raises a different question, why is the one in data table working with post?
            axios.post(`${config.apiUrl}/data/${projectId}`, {
                authorization: idToken,
                data: packetData,
            }).then((response) => {
                console.log(response);
            }).catch((err) => { console.log(err) })


        })
    }

    const  exportData = () => {
        var filename = "data.csv";
        var textToSave = "Date,Time,Unix Time(ms),cm,cm/s\n";
        if (packetData) {
            for (var dataLine of packetData) {
                for (var i = 0; i < dataLine.length; i++) {
                    if (i === 0) {
                        textToSave += dataLine[0];
                    } else {
                        textToSave += "," + dataLine[i];
                    }
                }
                textToSave += "\n";

            }
            var newFile = new Blob([textToSave], { type: 'plain/text' });
            var a = document.createElement("a"),
                url = URL.createObjectURL(newFile);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }

    }

    function pickFile() {
        if (document.getElementById("loadData") !== null) {
            document.getElementById("loadData").click();
        }

    }

    function importData() {
        var parsedFile = [];

        const input = document.getElementById("loadData");
        const file = input.files[0];
        var fileReader = new FileReader();

        fileReader.onload = function (fileLoadedEvent) {
            var textFromFileLoaded = fileLoadedEvent.target.result;
            var textInLines = textFromFileLoaded.split("\n"); //create an array of lines
            textInLines.shift(); //remove header; we assume it exists but should probably check

            for (var line of textInLines) {
                var lineData = line.split(",");
                parsedFile.push(lineData);
            }

            store.dispatch(load(parsedFile))
        }

        fileReader.readAsText(file, "UTF-8");

    }

    return(
        <div id='testDataTable' style={{ overflow: "scroll", height: "100%", width: "100%" }}>
            
            <div style={{borderBottom: '1px solid #ccc', padding: '10px', marginBottom: '10px', position:'absolute', backgroundColor: 'white', width: '98%', zIndex: 1, boxShadow: '0 4px 2px -2px rgba(0,0,0,0.1)'}}>
                {dataModalOpen ? <OpenDataModal toggleModal={toggleModal} pid={projectId} /> : null}
                

                <span className='dataTableButtons' onClick={exportData.bind(this)}>Export</span>
                <input id="loadData" type="file" accept=".csv, .pac" onChange={() => importData()} style={{ display: "none" }} /> {/*This line may or maynot be necessary*/}
                <span className='dataTableButtons' onClick={pickFile} style={{ marginLeft: "20px"}}>Import</span>
                <span className='dataTableButtons' onClick={()=>clearPacketData()} style={{marginLeft: "20px"}}>Clear</span>
                
                {projectId && packetData ?
                    <>
                        <span className='dataTableButtons' onClick={saveToCloud} style={{ marginLeft: "20px" }}>Save</span>
                        <span className='dataTableButtons' onClick={() => { toggleModal() }} style={{ marginLeft: "20px"}}>Open</span>
                    </>
                    :
                    <>
                        <span style={{ marginLeft: "20px", color: 'gray' }}>Save</span>
                        <span style={{ marginLeft: "20px", color: 'gray' }}>Open</span>
                    </>
                }
            </div>

            <table style={{ width: "80%", paddingTop:'50px'}}>
                <thead style={{ textAlign: "center" }}>
                    <tr>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Unix Time(ms)</th>
                        <th>cm</th>
                        <th>cm/s</th>
                        {/* <th>cm/s²</th> */} 
                    </tr>
                </thead>
                <tbody style={{ textAlign: 'center' }}>
                    {packetData.map(dataLine => {
                        row++;//added to stop getting warnings about matching keys when time is the same (less than a second)
                        return (
                            <tr key={`${dataLine[0]}row${row}`}>
                                <td key={`${dataLine[0]}${row}date`} >{dataLine[0]}</td>
                                <td key={`${dataLine[0]}${row}time`}>{dataLine[1]}</td>
                                <td key={`${dataLine[0]}${row}unix`}>{dataLine[2]}</td>
                                <td key={`${dataLine[0]}${row}ping`}>{dataLine[3]}</td>
                                <td key={`${dataLine[0]}${row}ms`}>{dataLine[4]}</td>
                                {/* <td key={`${dataLine[0]}${row}ms2`}>{dataLine[5]}</td> */}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default MotionTable;